import { useTranslation } from "react-i18next";

import { ErrorComponent } from "../components/pages/Error";
import { getSignOutUrl } from "../services/auth";
import { Link } from "react-router-dom";
import classNames from "classnames";

const linkClass =
    "flex items-center gap-2 rounded font-light px-3 py-2 hover:bg-neutral-700 hover:text-white hover:no-underline active:bg-neutral-600 rounded-sm text-base";

export default function NoAccess() {
    const { t } = useTranslation();
    return (
        <>
            <ErrorComponent
                title={t("NO-ACCESS-TITLE")}
                description={t("NO-ACCESS-DESCRIPTION")}
                logoutButton={true}
            />
        </>
    );
}
